import React, { useState, useEffect } from "react";
import ShareTable from "../../../shares/tables/ShareTable";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Modal, CircularProgress } from "@mui/material";
import AddBooks from "./modals/AddBooks";
import useFetch from "../../../../hooks/useFetch";
import Search from "../../../shares/search/Search";
import { useSearchParams } from "react-router-dom";
import {
  PageHeader,
  TableAction,
} from "../../../shares/dashboard/DashboardWidgets";

const Books = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [newModal, setNewModal] = useState(false);
  const [edit, setEdit] = useState(null);
  const [books, setBooks] = useState();
  const [id, setId] = useState();

  const handleClose = () => {
    setNewModal(false);
    setEdit(null);
  };

  const handleEdit = (id) => {
    setNewModal(true);
    setEdit(id);
  };

  const getBooks = useFetch({
    method: "GET",
    url: `management/books/`,
    noHeader: false,
    trigger: true,
    setter: setBooks,
  });

  const deleteBooks = useFetch({
    method: "DELETE",
    url: `management/books/${id}/`,
    noHeader: false,
    trigger: false,
    caller: getBooks,
  });

  const columns = [
    { id: "booksname", label: "نام" },
    {
      id: "edit",
      label: "ویرایش",
      render: (row) => (
        <TableAction
          icon={EditIcon}
          onClick={() => handleEdit(row.id)}
          label="ویرایش جزوه"
        />
      ),
    },
    {
      id: "delete",
      label: "حذف",
      render: (row) =>
        deleteBooks.loading && id === row.id ? (
          <CircularProgress size="2rem" color="inherit" className="text-danger" />
        ) : (
          <TableAction
            icon={DeleteIcon}
            onClick={() => setId(row.id)}
            label="حذف جزوه"
            tone="danger"
          />
        ),
    },
  ];

  useEffect(() => {
    id && deleteBooks.reFetch();
  }, [id]);

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      <PageHeader
        title="جزوات"
        description="مدیریت جزوه‌ها و منابع درسی"
        icon={MenuBookOutlinedIcon}
        actionLabel="افزودن جزوه"
        actionIcon={AddRoundedIcon}
        onAction={() => setNewModal(true)}
      />

      <div className="flex flex-col gap-lg">
        <Search getFiltered={getBooks} />

        <ShareTable
          data={books?.results ?? []}
          columns={columns}
          getPage={getBooks}
          totalCount={books?.count}
          page={Number(searchParams.get("page")) || 1}
          setPage={setSearchParams}
        />
      </div>

      <Modal
        open={newModal}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddBooks close={handleClose} get={getBooks} edit={edit} />
      </Modal>
    </div>
  );
};

export default Books;
